import { Fragment, useContext, useEffect, useState } from 'react';
import clienteAxios from '../config/axios';
import Spinner from '../components/spinners/Spinner';

/// fade del modal
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';

// importacion del modal
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

/// vamos a poner el tipo de dato
import PropTypes from 'prop-types';

import PanelOperacion from '../components/mercado/PanelOperacion';
import '../components/mercado/mercado.css';
import AuthContext from '../context/autenticacion/authContext.js';
import { useT } from 'i18n';

import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';

import DefaultPanther from '../components/02.jpg';

import { autoPlay } from 'react-swipeable-views-utils';

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

//// responsive
// pantalla grande
/// aqui vamos a poner los estilos para el tap 
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  rootlinear: {
    width: '100%',
  },
}));

const ProductosDeInversion = ({ apiload, ApiLoad }) => {
  const { t, ts } = useT();

  const authContext = useContext(AuthContext);
  const {
    proyectos_primario,
    proyectos_primario_all,
    proyectos_primario_all_cantidad,
    CerrarSesion,
  } = authContext;

  const theme = useTheme();

  const [cargando, guardarCargando] = useState(false);
  const [parcelas, guardarAsociadas] = useState([]);
  const [proyecto, guardarProyectos] = useState([]);

  /////// estilos del carousel de productos
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  const [cantidad, guardarCantidades] = useState({});

  useEffect(() => {
    const consultarApiProductos = async () => {
      try {
        guardarCantidades(proyectos_primario_all_cantidad || 0);
        guardarProyectos(proyectos_primario_all || []);
      } catch (error) {
        CerrarSesion();
      }
    };

    consultarApiProductos();
  }, [apiload, proyectos_primario, proyectos_primario_all, proyectos_primario_all_cantidad, CerrarSesion]);

  const maxSteps = cantidad;

  // vamos a pasarle el la informacion de la fila al modal
  const [modalInfo, setModalInfo] = useState([]);

  // vamos a hacer que el mensaje salga
  const [mensaje, guardarMensaje] = useState('');

  // configuracion del modal de material-ui
  const [open, setOpen] = useState(false);

  const classes = useStyles();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    guardarMensaje(null);
  };

  // estamos creando el state 
  const [contratomonto, guardarContratoMonto] = useState({
    amount: ''
  });

  const [project_id, guardarProjectid] = useState({
    project_id: ''
  });

  const crearInversion = async inversion => {
    const amount = document.getElementById('amount')?.value;

    try {
      const respuesta = await clienteAxios.post('/api/client/investments/create', { amount, project_id: project_id.project_id });
      guardarMensaje(ts(respuesta.data.message));

      setTimeout(() => {
        guardarMensaje(null);
      }, 5000);
    } catch (error) {
      guardarMensaje(ts(error.response?.data?.message) || t('productos.errCrear'));
      setTimeout(() => {
        guardarMensaje(null);
        setOpen(false);
      }, 5000);
    }
  };

  // funcion de numero
  function currencyFormat(num) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + ' USDT';
  }

  const onChange = e => {
    const x = parseFloat(document.getElementById("amount")?.value || 0);

    if (!isNaN(x) && x !== "") {
      const porcentaje_diario = modalInfo.porcentaje_diario || 0;
      const dias = modalInfo.dias || 0;
      let calculo = (dias * porcentaje_diario * x) / 100 + x;
      if (!Number.isNaN(calculo)) {
        const totalElement = document.getElementById("totalarecibir");
        if (totalElement) totalElement.innerHTML = currencyFormat(calculo);
      }
    } else {
      const totalElement = document.getElementById("totalarecibir");
      if (totalElement) totalElement.innerHTML = "0";
    }

    guardarContratoMonto({
      [e.target.name]: parseFloat(e.target.value) || 0
    });
  };

  /// cuando el usuario quiere iniciar sesion
  const onSubmit = e => {
    e.preventDefault();
    guardarCargando(true);
    crearInversion({ contratomonto, project_id });
  };

  return (
    <Fade in={open} onClose={handleClose} timeout={1000}>
      <Fragment>
        {cantidad > 0 ? (
          <Col sm="12" xl="12" lg="12" md="12" className="height-fix-productos-inversion">
            <Card>
              <div>
                <CardHeader>
                  <div className="header-container-pro">
                    <div>
                      <CardTitle tag="h2" className="card-title-fix">{t('productos.titulo')}</CardTitle>
                      <small className="fix-mov-title mb-1"> {t('productos.escoge')}</small>
                    </div>
                    <div>
                      <MobileStepper
                        steps={maxSteps}
                        position="static"
                        variant="text"
                        activeStep={activeStep}
                        className="MobileSteper-Fix"
                        nextButton={
                          <Button size="small" onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                            {t('productos.siguiente')}
                          </Button>
                        }
                        backButton={
                          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
                            {t('productos.atras')}
                          </Button>
                        }
                      />
                    </div>
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col>
                      <div className={classes.root}>
                        <AutoPlaySwipeableViews
                          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                          index={activeStep}
                          onChangeIndex={handleStepChange}
                          enableMouseEvents
                          className="proyectos-fix-steper"
                          interval={90000}
                        >
                          {proyecto.map((step, index) => (
                            <div key={step.id} className="proyectos-fix-steper">
                              {Math.abs(activeStep - index) <= 2 ? (
                                <article className="p7-prod">
                                  <header className="p7-prod-top">
                                    <div>
                                      <h3>{step.name}</h3>
                                      <span className="p7-prod-sub">{step.tipo}{step.nrocontrato ? ` · ${t('productos.contrato', { nro: step.nrocontrato })}` : ''}</span>
                                    </div>
                                    <button
                                      type="button"
                                      className="p7-btn-gold"
                                      onClick={() => {
                                        handleOpen();
                                        guardarProjectid({ project_id: step.id });
                                        setModalInfo(step);
                                      }}
                                    >
                                      {t('productos.invertir')}
                                    </button>
                                  </header>

                                  <div className="p7-prod-body">
                                    <img src={DefaultPanther} className="p7-prod-img" alt="" />
                                    <p className="p7-prod-desc">{step.name === "" ? <Spinner /> : step.description}</p>
                                  </div>

                                  <div className="p7-prod-progress">
                                    <div className="p7-prod-progress-top">
                                      <span>{t('productos.pctOferta', { pct: step.percentage_investment })}</span>
                                      <span>{t('productos.montoDe', { a: step.amount_invertido, b: step.amount_proyecto })}</span>
                                    </div>
                                    <div className={classes.rootlinear}>
                                      <LinearProgress variant="determinate" value={parseInt(step.percentage_investment) || 0} />
                                    </div>
                                  </div>

                                  <dl className="p7-prod-datos">
                                    <div><dt>{t('productos.clasificacion')}</dt><dd>{step.risk}</dd></div>
                                    <div><dt>{t('productos.garantia')}</dt><dd>{step.warranty}</dd></div>
                                    <div><dt>{t('productos.participantes')}</dt><dd>{step.total_inversores}</dd></div>
                                    <div><dt>{t('productos.tasa')}</dt><dd>{step.tax_referential_client}%</dd></div>
                                    <div><dt>{t('productos.fin')}</dt><dd>{step.end_date}</dd></div>
                                    <div><dt>{t('productos.plazo')}</dt><dd>{t('productos.dias', { n: step.dias })}</dd></div>
                                    <div><dt>{t('productos.restante')}</dt><dd>{t('productos.dias', { n: step.tiemporemanente })}</dd></div>
                                    <div><dt>{t('productos.montoProyecto')}</dt><dd>{t('productos.monto', { n: step.amount_proyecto })}</dd></div>
                                  </dl>
                                </article>
                              ) : null}
                            </div>
                          ))}
                        </AutoPlaySwipeableViews>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </Card>
          </Col>
        ) : (
          <Col sm="12" xl="12" lg="12" md="12" className="height-fix-productos-inversion">
            <Card>
              <div>
                <CardBody className="d-flex justify-content-center">
                  <Row className="box-depositos-seleccion-alerta justify-content-center col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <Col sm="12" xl="12" lg="12" md="12" className="panther-open-titulo-alerta border-panther">
                      {cantidad === 0 ? (
                        <>
                          <i className="tim-icons icon-spaceship animation-icon-in mb-1" />
                          <h2 className="animation-icon-in-dos mb-4">{t('productos.vacioTitulo')}</h2>
                          <h3 className="animate-raya-03 mb-2">{t('productos.vacioMsg')}</h3>
                          <p className="text-center animation-icon-in-cuatro ">{t('productos.vacioPie')}</p>
                        </>
                      ) : (
                        <Spinner />
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </Card>
          </Col>
        )}

        {open && modalInfo && (
          <PanelOperacion p={modalInfo} secundario={false} onCerrar={handleClose} onHecho={ApiLoad} />
        )}
      </Fragment>
    </Fade>
  );
};

export default ProductosDeInversion;